<div class="page-layout-container">
  <h1 class="title">Fill Employee TimeSheet</h1>
  <div class="row">
    <div class="col">
      <app-emp-name
        [filterEmpName]="filterEmpName"
        (empName)="empNameSelected($event)"
      >
      </app-emp-name>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>Select Date</mat-label>
        <input
          matInput
          [matDatepicker]="timeSheetDate"
          required
          [(ngModel)]="selectedDate"
          (dateChange)="fetchTimesheet()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="timeSheetDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #timeSheetDate> </mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col">
      <button
        type="button"
        class="btn btn-primary ms-3"
        data-bs-toggle="modal"
        (click)="fetchTimesheet()"
        data-bs-target="#exampleModalToggle2"
      >
        GET Timesheet
      </button>
    </div>
  </div>
  <div class="alert alert-danger">
    Please use the 'Timesheet-Invoice' menu to generate invoices. Peppol
    Invoices cannot be created from this page.
  </div>
  <div *ngIf="status === 'Success'" class="alert alert-success">
    Timesheet saved successfully
  </div>
  <div *ngIf="status === 'Failed'" class="alert alert-danger">
    Due to technical error timesheet is not saved
  </div>
  <div *ngIf="status === 'invoiceFailed'" class="alert alert-danger">
    Invoice generation failed, please contact technical team for the issue
  </div>

  <div class="modal-body" *ngIf="dataLoaded">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col" style="color: rgb(62, 0, 128)">
              <span>TS Required Flag</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128)">
              <span>Logged Hrs</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128)">Invoice</th>
            <th scope="col" style="color: rgb(62, 0, 128)">Credit Note</th>
            <!---->
            <th
              *ngFor="let hd of header"
              scope="col"
              style="color: rgb(62, 0, 128)"
            >
              <span>{{ hd.dayName }}<br />{{ hd.day }}</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128); width: 225px">
              <span>Extra Hrs Amount</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128); width: 225px">
              <span>Comments</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128); width: 225px">
              <span>HR Comments</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128); width: 225px">
              <span>Account Comments</span>
            </th>
            <th scope="col" style="color: rgb(62, 0, 128); width: 225px">
              <span>Enable TimeSheet</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let j = index">
            <td style="width: 10%; color: rgb(62, 0, 128)" scope="row">
              {{ row.contractId }}
            </td>
            <td style="width: 10%" scope="row">
              {{ row.tsRequiredFlag }}
            </td>
            <td style="width: 10%" scope="row" [(ngModel)]="row.noOfHrs">
              {{ row.noOfHrs }}
            </td>
            <td style="padding-top: 20px">
              <button
                *ngIf="row.contractType == 'Billing'"
                mat-raised-button
                (click)="downloadInvoice(row.contractId)"
              >
                Invoice Download
              </button>
            </td>
            <td style="padding-top: 20px">
              <button
                mat-raised-button
                (click)="downloadCreditNote(row.contractId)"
              >
                CN Download <br />
              </button>
              <label>{{ row.cancelledInvoice }}</label>
            </td>
            <td
              *ngFor="let timeData of row.contractTimeSheetList; let i = index"
            >
              <span *ngIf="timeData.isDisabled; else editPlace">
                <input
                  class="form-control"
                  type="text"
                  placeholder=""
                  disabled
                  style="color: red"
                  [ngModel]="timeData.filledData"
                  aria-label=""
                />
              </span>
              <ng-template #editPlace>
                <input
                  class="form-control"
                  type="text"
                  placeholder=""
                  inputmode="decimal"
                  onKeyUp="if(this.value>9){this.value='9';}else if(this.value<0){this.value='0';}"
                  [value]="row.contractId"
                  (change)="calculateHours($event)"
                  [(ngModel)]="row.contractTimeSheetList[i].filledData"
                  aria-label=""
                />
              </ng-template>
            </td>
            <td style="align-items: center" scope="row">
              <input
                class="form-control"
                type="text"
                placeholder=""
                [(ngModel)]="row.extraHrsAmt"
                aria-label=""
              />
            </td>
            <td style="align-items: center" scope="row">
              <input
                class="form-control"
                type="text"
                placeholder=""
                [(ngModel)]="row.comments"
                aria-label=""
              />
            </td>
            <td style="align-items: center" scope="row">
              <input
                class="form-control"
                type="text"
                placeholder=""
                [(ngModel)]="row.hrComments"
                aria-label=""
              />
            </td>
            <td style="align-items: center" scope="row">
              <input
                class="form-control"
                type="text"
                placeholder=""
                [(ngModel)]="row.accComments"
                aria-label=""
              />
            </td>
            <td style="align-items: center" scope="row">
              <div *ngIf="isAdmin">
                <button
                  type="button"
                  class="btn btn-primary ms-3"
                  data-bs-toggle="modal"
                  (click)="enableTimesheet(row.contractId)"
                  data-bs-target="#exampleModalToggle2"
                >
                  Enable TimeSheet
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="col-md-12 mt-3" style="text-align: center">
        <button
          type="button"
          class="btn btn-primary ms-3"
          data-bs-toggle="modal"
          (click)="updateTimeSheet()"
          data-bs-target="#exampleModalToggle2"
        >
          Submit
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body" *ngIf="dataLoaded">
    <div class="table-responsive" *ngIf="documentList.length > 0">
      <h1 class="title">Uploaded TimeSheet Files</h1>
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th>File Name</th>
            <th>Status</th>
            <th>Uploaded By</th>
            <th>Uploaded Date</th>
            <th>Download Timesheet</th>
            <th>Delete Timesheet</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of documentList">
            <td>
              {{ doc?.fileName }}
            </td>
            <td>
              {{ doc?.docStatus }}
            </td>
            <td>
              {{ doc?.uploadedBy }}
            </td>
            <td>
              {{ doc?.uploadedDate | date : "dd/MMM/yyyy" }}
            </td>
            <td>
              <button
                type="button"
                class="btn btn-secondary"
                (click)="download(doc?.fileName)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                  ></path>
                  <path
                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                  ></path>
                </svg>
              </button>
            </td>
            <td>
              <Button
                type="button"
                class="btn btn-secondary"
                (click)="delete(doc?.fileName)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"
                  />
                  <path
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"
                  />
                </svg>
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-body" *ngIf="overTimeFlag">
    <div class="table-responsive" *ngIf="overTimeList.length > 0">
      <h1 class="title">OverTime</h1>
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th style="display: none">OverTime ID</th>
            <th style="display: none">TimeSheet ID</th>
            <th>Contract ID</th>
            <th>Description</th>
            <th>Quantity</th>
            <th>Days/Hours</th>
            <th>Rate</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let overTime of overTimeList; let i = index">
            <td style="display: none">
              {{ overTime?.overTimeId }}
            </td>
            <td style="display: none">
              {{ overTime?.timesheetId }}
            </td>
            <td>
              {{ overTime?.nishContractId }}
            </td>
            <td>
              {{ overTime?.overTimeDesc }}
            </td>
            <td id="overTimeQty">
              <input
                class="form-control"
                type="text"
                placeholder=""
                (change)="calculateOT($event, i)"
                [(ngModel)]="overTime.overTimeQty"
                aria-label=""
              />
            </td>
            <td>
              {{ overTime?.overTimeDH }}
            </td>
            <td>
              {{ overTime?.overTimeRate }}
            </td>
            <td [(ngModel)]="overTime.overTimeAmount">
              {{ overTime?.overTimeAmount }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="col-md-12 mt-3" style="text-align: center">
        <button
          type="button"
          class="btn btn-primary ms-3"
          data-bs-toggle="modal"
          (click)="updateOTTimeSheet()"
          data-bs-target="#exampleModalToggle2"
        >
          Submit TimeSheet
        </button>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="dataLoaded">
    <div class="alert alert-danger">
      Don't upload the timesheets with the same file names, it will over ride
      existing uploaded files
    </div>
  </div>

  <div class="row mt-3" *ngIf="dataLoaded">
    <div class="col-5 margin-auto">
      <file-upload [control]="fileUploadControl" class="upload"></file-upload>
    </div>
    <div class="col-5 margin-auto">
      <div class="d-flex">
        <mat-label class="col-6 margin-auto">Document Name </mat-label>
        <div class="col-6 file-list margin-auto">
          <div
            class="file-item"
            *ngFor="let file of fileUploadControl?.value"
            (click)="fileUploadControl.removeFile(file)"
          >
            {{ file.name }}
          </div>
        </div>
      </div>

      <div class="col-2 margin-auto">
        <button mat-button (click)="upload()" type="submit">Upload</button>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-beat"
  ><p style="color: white">Uploading...</p></ngx-spinner
>
